<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <!-- <template v-slot:activator="{ on, attrs }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-title>Receive Payment</v-list-item-title>
      </v-list-item>
    </template> -->
    <v-card v-if="selectedInvoice">
      <!-- selectedMerchant: {{ selectedMerchant.id }} - {{ payCompassId }} -->
      <ModelTitle :title="`Receive Payment # ${selectedInvoice.localId}`" @close="close()" />
      <v-container grid-list-lg>


        <v-select class="mt-5" dense outlined :items="MerchantAccount" v-model="selectedMerchant" return-object
          item-text="name" label="Select Merchant"></v-select>
<!-- 
        selectedMerchant: {{ selectedMerchant }} -->
        <v-layout row justify-space-around class="mb-5 mx-5 py-5" v-if="isCustomer">

          <v-flex>
            <v-layout column align-center>
              <v-flex class="pb-0 font-weight-medium">Masjid Due</v-flex>
              <v-flex class="py-0">{{ donationPay | currency }}</v-flex>
              <v-flex class="red--text py-0">-{{ totalDonationCollected | currency }}</v-flex>
              <div style="width: 85px; border: 1px solid black;"></div>
              <v-flex class="font-weight-bold pt-0">{{ donationPay - totalDonationCollected | currency }}</v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout column align-center>
              <v-flex class="pb-0 font-weight-medium">Parent Pay</v-flex>
              <v-flex class="py-0">{{ parentPay | currency }}</v-flex>
              <v-flex class="red--text py-0">-{{ totalParentPaymentCollected | currency }}</v-flex>
              <div style="width: 85px; border: 1px solid black;"></div>
              <v-flex class="font-weight-bold pt-0">{{ parentPay - totalParentPaymentCollected | currency }}</v-flex>
            </v-layout>
          </v-flex>
          <v-flex style="background-color: #F5F5F5;">
            <v-layout column align-center>
              <v-flex class="pb-0 font-weight-medium">Invoice Due</v-flex>
              <v-flex class="py-0">{{ donationPay + parentPay | currency }}</v-flex>
              <v-flex class="red--text py-0">-{{ totalParentPaymentCollected + totalDonationCollected | currency
                }}</v-flex>
              <div style="width: 85px; border: 1px solid black;"></div>
              <v-flex class="font-weight-bold pt-0">{{ totalDueBalance | currency }}</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- <div class="text-center mt-4">
          <div>Invoice Due: <span>{{ selectedInvoice.due | currency
          }}</span></div>
          <div>Masjid Due: <span>{{ donationPay | currency
          }}</span></div>
          <div>Parent Pay: <span>{{ parentPay | currency
          }}</span></div>
        </div> -->


        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <DateSelector :initValue="Payment.date" label="Payment Date" v-model="Payment.date" />
          </v-flex>
          <v-flex xs12>
            <v-text-field dense outlined v-model="Payment.note" label="Memo" hide-details></v-text-field>
          </v-flex>
        </v-layout>


        <v-subheader>
          <v-layout row wrap justify-space-between>
            <v-flex v-if="isCustomer">
              <v-checkbox class="ma-0 pa-0" v-model="Payment.parent" label="Parent Pay" color="red" :value="false"
                hide-details>
              </v-checkbox>
            </v-flex>
            <v-flex>
              <v-checkbox class="ma-0 pa-0" v-model="collectedOnline" label="Collect Online" color="red" :value="false"
                hide-details>
              </v-checkbox>
            </v-flex>
          </v-layout>
        </v-subheader>



        <v-layout row v-if="Payment.parent">


          <v-flex xs6>
            <v-select dense outlined :items="paymentMethods" v-model="Payment.paymentMethod" label="Payment Method"
              item-text="name" hide-details return-object></v-select>
          </v-flex>
          <v-flex xs6>
            <v-text-field class="al-r" type="number" outlined dense hide-details v-model="Payment.amount"
              label="Amount"></v-text-field>
          </v-flex>

          <v-flex xs6>
            <v-text-field outlined dense hide-details v-model="Payment.referenceNumber"
              label="Reference Number"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="collectedOnline">
            <v-select item-text="last4" return-object v-model="selectedCard" :loading="loadingCard" outlined dense
              hide-details :items="cards" label="Select Card">
              <template slot="item" slot-scope="{ item }">
                <span>{{ item.last4 }}</span>
                <v-spacer></v-spacer>
                <span class="text-capitalize">{{ item.payment_method_type
                  }}</span>
              </template></v-select>
          </v-flex>

        </v-layout>

        <v-subheader v-if="isCustomer">
          <v-checkbox class="ma-0 pa-0" v-model="Payment.donation" label="Donation Payment" color="red" :value="false"
            hide-details>
          </v-checkbox>
        </v-subheader>


        <v-layout v-if="Payment.donation" row>
          <v-flex xs6>
            <v-select dense outlined :items="paymentMethods" v-model="Payment.donationPaymentMethod"
              label="Payment Method" item-text="name" hide-details return-object></v-select>
          </v-flex>
          <v-flex xs6>
            <v-text-field class="al-r" type="number" outlined dense hide-details v-model="Payment.donationAmount"
              label="Amount"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field outlined dense hide-details v-model="Payment.donationReferenceNumber"
              label="Reference Number"></v-text-field>
          </v-flex>

        </v-layout>

        <!-- <div v-if="paymentType === 'online'">
          <v-layout row class="mt-5" justify-center>
            <v-flex xs12>
              <DateSelector :initValue="Payment.date" label="Payment Date" v-model="Payment.date" />
            </v-flex>
            
            <v-flex xs4>

              <v-text-field class="al-r" outlined dense hide-details v-model="Payment.amount"
                label="Amount"></v-text-field>
            </v-flex>

          </v-layout>
        </div> -->





      </v-container>

      <v-divider></v-divider>

      <v-card-actions>
        <small>Total payment will be collected: <span class="font-weight-bold">{{ totalCollected() | currency
            }}</span></small>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :disabled="submitStatus()" :loading="loadingBtn" @click="submit()">Submit</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import invoiceService from "@/modules/Invoice/service.js";
import DateSelector from "@/components/DateSelector";
import payCompassService from "@/modules/PayCompass/service.js";
import paymentService from "@/modules/Payment/service.js";
import donationCategoryService from "@/modules/DonationCategory/service.js";
import donorService from "@/modules/Donors/service.js";
import customerService from "@/modules/Customer/service.js";

export default {
  name: 'payment-receive-from-payment',
  props: ['Invoice', 'openReceivePaymentDialog'],
  data() {
    return {
      Customer: null,
      selectedMerchant: null,
      MerchantAccount: [],
      isCustomer: false,
      collectResult: null,
      collectedOnline: false,
      dialog: false,
      loadingCard: false,
      selectedInvoiceParentPayDue: 0,
      selectedInvoice: null,
      paymentType: 'manual',
      loadingBtn: false,
      selectedCard: null,
      Payment: {
        CustomerId: 0,
        date: this.$moment().toISOString(),
        referenceNumber: null,
        donationReferenceNumber: null,
        paymentMethod: "Online",
        donationPaymentMethod: "Masjid",
        PaymentDetails: [],
        amount: 0,
        donationAmount: 0,
        donation: false,
        parent: false,
        note: null,
      },
      paymentMethods: [
        'Stripe',
        'Online',
        'Mohid',
        "Cash",
        "Check",
        "Paypal",
        "Debit Card",
        "Credit Card",
        "Wire",
        "Quick Pay",
        "Cash App",
        "Exchange",
        "Masjid",
        "Zelle",
        "Other",
      ],
      cards: [],
      dueAmount: 0,
      parentPay: 0,
      donationPay: 0,
      totalDonationCollected: 0,
      totalParentPaymentCollected: 0,
    }
  },
  computed: {
    totalDueBalance() {
      return (this.donationPay + this.parentPay) - (this.totalParentPaymentCollected + this.totalDonationCollected)
    }
  },
  watch: {
    selectedMerchant(val) {
      // console.log('val', val)
      // console.log('customer', this.getCustomer)
      if (val) {
        // this.cards = []
        this.getCard()
      }

    },
    async collectedOnline(val) {
      if (val) {
        //console.log('this.selectedInvoice.Customer', this.selectedInvoice.Customer)
        if (this.isCustomer) {
          this.getCard(this.selectedInvoice.Customer)
        } else {
          this.getCard(this.selectedInvoice.Donor)
        }
        this.Payment.date = this.$moment().toISOString()
      }
    },
    // paymentType(val) {
    //   if (val === 'online') {
    //     this.Payment.date = this.$moment().toISOString()
    //   } else {
    //     this.Payment.date = this.$moment(this.selectedInvoice.date).toISOString()
    //   }

    // },
    openReceivePaymentDialog(val) {
      this.dialog = val
    },
    async dialog(val) {
      if (val) {
        console.log('calling invoice', this.Invoice)
        await this.getCustomer()
        await this.merchantServiceList()
        this.getInvoice()
      }
    }
  },
  components: {
    DateSelector,
  },
  methods: {
    async getCustomer() {
      if (this.Invoice.DonorId) {
        this.Customer = (await donorService.getById(this.Invoice.DonorId)).data
      } else {
        this.Customer = (await customerService.getById(this.Invoice.CustomerId)).data
      }

      console.log('Customer', this.Customer)
    },
    merchantServiceList() {
      return donationCategoryService.getAll().then((response) => {
        // this.loading = false;
        //console.log('response merchant', response)
        this.MerchantAccount = response.data;
        this.selectedMerchant = this.MerchantAccount[1]
        // this.itemsPerPage = this.merchants.length
      });
    },
    submitStatus() {
      if (this.totalDueBalance >= this.totalCollected()) {
        return false
      } else {
        return true
      }
    },
    totalCollected() {
      let total = 0
      if (this.Payment.parent) {
        total += parseFloat(this.Payment.amount)
      }
      if (this.Payment.donation) {
        total += parseFloat(this.Payment.donationAmount)
      }
      return total
    },
    getCard() {
      this.cards = []
      this.payCompassId = null
      this.Customer.MerchantCustomers.map(row => {
        if (row.DonationCategoryId === this.selectedMerchant.id) {
          this.payCompassId = row.payCompassId
        }
      })
      console.log('payCompassId', this.payCompassId)
      payCompassService.getAllCard(this.payCompassId, { donationCategoryId: this.selectedMerchant.id }).then(response => {
        //console.log('card list', response)
        this.cards = response.data
        if (this.cards.length === 1) {
          this.selectedCard = this.cards[0]
        }
      })
    },
    async submit() {
      // console.log('in here', this.collectedOnline, this.selectedCard)
      if (this.collectedOnline && !this.selectedCard) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Select card on file",
          });
        return false
      }

      this.loadingBtn = true
      if (this.isCustomer) {
        this.Payment.CustomerId = this.selectedInvoice.CustomerId
      } else {
        this.Payment.DonorId = this.selectedInvoice.DonorId
      }

      if (this.Payment.parent && this.Payment.amount !== 0) {
        let payment = {
          amount: this.Payment.amount,
          referenceNumber: this.Payment.referenceNumber,
          InvoiceId: this.selectedInvoice.id,
          donation: false
        }
        if (this.collectedOnline) {
          payment.donationCategoryId = this.selectedMerchant.id
        }
        console.log(';alksdjfa;lskdfj', payment)
        this.Payment.PaymentDetails.push(payment)
      }
      if (this.Payment.donation && this.Payment.donationAmount !== 0) {
        this.Payment.PaymentDetails.push({
          amount: this.Payment.donationAmount,
          referenceNumber: this.Payment.donationReferenceNumber,
          InvoiceId: this.selectedInvoice.id,
          donation: this.Payment.donation
        })
      }
      // console.log('this.Payment', this.Payment)
      if (this.collectedOnline) {
        this.collectResult = await this.collectPayment()
        // console.log('this.collectResult', this.collectResult)
        if (this.collectResult) {
          this.savePayment()
        }
        this.$events.emit("invoiceListEvent");
      } else {
        this.savePayment()
      }

      // console.log('collectResult', collectResult)
      // this.savePayment()
      // if (this.paymentType === 'online') {
      //   this.collectPayment()
      // } else {
      //   this.savePayment()
      // }
    },
    async collectPayment() {
      try {
        let payment = {
          amount: this.Payment.amount,
          description: `Invoice #${this.selectedInvoice.localId}, IntId: ${this.selectedInvoice.id}`,
          source: this.selectedCard.id,
          customer: (this.isCustomer ? this.selectedInvoice.Customer.payCompassId : this.selectedInvoice.Donor.payCompassId),
          cardId: this.selectedCard.id,
          selectedInvoice: this.selectedInvoice,
          donationCategoryId: this.selectedMerchant.id
        }
        console.log('payment', payment)
        const paymentResponse = await payCompassService.chargeCustomer(payment)
        console.log('response payment', paymentResponse)
        if (paymentResponse && paymentResponse.data && paymentResponse.data.status_code === 'A') {
          this.Payment.referenceNumber = `${this.selectedCard.payment_method_type}-${this.selectedCard.last4}`
          this.Payment.PaymentDetails[0].stripeChargeId = paymentResponse.data.reference_number
          this.Payment.donation = false
          this.Payment.parent = true
          this.Payment.PaymentDetails[0].metadata = paymentResponse.data
          return paymentResponse
        } else {
          this.$swal(paymentResponse.data.status, paymentResponse.data.error_message, 'error')
          this.loadingBtn = false
          return false
        }
      } catch (error) {
        console.log('error', error)
        this.loadingBtn = false
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: error.data.message,
          });
        return false
      }


    },
    savePayment() {
      return paymentService.create(this.Payment).then(() => {

        this.$events.emit("invoiceListEvent");
        this.$events.emit("customerProfileEvent");
        this.loadingBtn = false
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: "Payment was created",
          });
        this.close()
      }).catch((err) => {
        this.loading = false;
        this.loadingBtn = false
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: err.data.message,
          });
      });
    },
    reset() {
      this.collectedOnline = false
      this.selectedCard = null
      this.loadingCard = false
      this.selectedInvoiceParentPayDue = 0
      this.selectedInvoice = null
      this.cards = []
      this.dueAmount = 0
      this.parentPay = 0
      this.donationPay = 0
      this.paymentType = 'manual'
      this.totalDonationCollected = 0
      this.loadingBtn = false
      this.totalParentPaymentCollected = 0
      this.Payment = {
        CustomerId: 0,
        date: this.$moment().toISOString(),
        referenceNumber: null,
        donationReferenceNumber: null,
        paymentMethod: "Online",
        donationPaymentMethod: "Masjid",
        PaymentDetails: [],
        amount: 0,
        donationAmount: 0,
        donation: false,
        parent: true,
      }
    },
    close() {
      this.reset()
      this.$emit('close')
      // this.paymentDialog = false
    },
    async getInvoice() {
      this.selectedInvoice = (await invoiceService.getById(this.Invoice.id)).data
      // console.log('this.selectedInvoice', this.selectedInvoice)

      this.selectedInvoice.InvoiceDetails.map(row => {
        // console.log('row', row)
        this.dueAmount += (row.price * row.qty)
        this.parentPay += (row.parentPay * row.qty)
        this.donationPay += (row.price * row.qty) - (row.parentPay * row.qty)
      })


      // console.log('parentPay', this.dueAmount, this.parentPay, this.donationPay)

      this.selectedInvoice.PaymentDetails.map(row => {
        // console.log('Receive Payment #', row)
        if (row.donation) {
          this.totalDonationCollected += row.amount
        } else {
          this.totalParentPaymentCollected += row.amount
        }
      })

      if (this.selectedInvoice.Customer) {
        this.isCustomer = true
        this.Payment.amount = this.parentPay - this.totalParentPaymentCollected
        this.Payment.donationAmount = this.donationPay - this.totalDonationCollected

        this.Payment.date = this.$moment(this.selectedInvoice.date).toISOString()
      } else {
        this.Payment.parent = true
        this.collectedOnline = true
        this.Payment.amount = this.selectedInvoice.due
        this.isCustomer = false
      }

      if (this.parentPay > 0) {
        this.Payment.parent = true
        this.collectedOnline = true
      }
      console.log('this.donationPay', this.donationPay)
      if (this.isCustomer) {
        if (this.donationPay > 0) {
          this.Payment.donation = true
        }
      }



    }
  },
}
</script>
<style scoped>
.hline {
  width: 86px;
  border: 1px solid black !important;
}
</style>
